<div class="esign-container">
  <div class="logo-section">
    <div class="logo-container">
      <img src="assets/Images/login/headerLogo.svg" alt="Header Logo" class="header-logo">
      <img src="assets/Images/login/sdexLogo.svg" alt="SDEX Logo" class="logo">
    </div>
  </div>
  <div class="card main-card">
    <div class="card-body">
      <h5 class="card-title">File Upload</h5>
      <div *ngIf="!uploadedFileName; else fileInfo" class="upload-section cursor-pointer"
        (click)="triggerFileInputClick()">
        <app-common-icon [loadingIcon]="isFileUploading" data-bs-toggle="tooltip" ngbTooltip="Upload File"
          [iconSrc]="'assets/Images/document-vault-images/Upload.svg'">
        </app-common-icon>
        <span class="main-text">Upload Your File</span>
        <p class="description">Maximum of 10 MB to be selected</p>
        <input style="display: none" #file type="file" accept="application/pdf" (change)="upload($event)" />
      </div>
      <ng-template #fileInfo>
        <div class="uploaded-file">
          <span>{{ uploadedFileName }}</span>
          <app-common-icon [iconSrc]="'assets/Images/user-management/Cross.svg'" class="cursor-pointer"
            ngbTooltip="Remove File" (click)="removeFile()">
          </app-common-icon>
        </div>
      </ng-template>
      <div *ngIf="uploadErrorMessage" class="alert alert-danger">
        {{ uploadErrorMessage }}
      </div>
      <form class="mb-3" [formGroup]="userForm">
        <div class="offcanvas__orgDetails">
          <div class="offCanvas__orgName-inputField">
            <app-input-filed label="Name" placeholder="Name" [control]="$any(userForm).controls['name']"
              [starIcon]="'*'">
            </app-input-filed>
            <div
              *ngIf="userForm.controls['name'].invalid && (userForm.controls['name'].dirty || userForm.controls['name'].touched)"
              class="alert_required">
              <small *ngIf="userForm.controls['name'].errors?.['required']" class="text-danger">Please enter a user
                name</small>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="offCanvas__phoneNumber-inputFiled">
            <app-input-filed label="Mobile Number" placeholder="Mobile Number" [maxDigits]="10" [starIcon]="'*'"
              [control]="$any(userForm).controls['phoneNumber']" [allowedType]="'number'">
            </app-input-filed>
            <div
              *ngIf="userForm.controls['phoneNumber'].invalid && (userForm.controls['phoneNumber'].dirty || userForm.controls['phoneNumber'].touched)"
              class="alert_required">
              <small *ngIf="userForm.controls['phoneNumber'].errors?.['required']" class="text-danger">Please enter
                phone number</small>
            </div>
            <div *ngIf="userForm.controls['phoneNumber'].errors?.['pattern']">
              <small class="text-danger">Please enter a valid mobile number</small>
            </div>
          </div>
        </div>
        <div class="buttons">
          <app-common-button buttonClass="smallFilledButton"  buttonLabel="Try e-Sign"
            [disabled]="userForm.invalid" (clickEvent)="onSubmit()">
          </app-common-button>
        </div>
      </form>
    </div>
  </div>

  <ng-template #paymentModal>
    <div class="payment-modal-wrapper">
      <div class="payment-header">
        <app-common-icon [iconSrc]="'assets/Images/user-management/Cross.svg'" class="cursor-pointer payment-close"
          ngbTooltip="Close" (click)="closePaymentModal()">
        </app-common-icon>
      </div>
      <iframe class="payment-iframe" *ngIf="paymentUrl" [src]="paymentUrl" title="Razorpay Payment"></iframe>
    </div>
  </ng-template>

  <div class="overlay-loader" *ngIf="verifyLoader">
    <div class="spinner"></div>
  </div>
</div>